import { environment } from '../../../environments/environment';
import { Dictionary } from '@ngrx/entity';
import { Injectable } from '@angular/core';

class ConfigDictionary implements Dictionary<boolean> {
    [id: string]: boolean;
}
@Injectable({
    providedIn: 'root'
})
export class FeatureFlagConfig {
    config = new ConfigDictionary();
    constructor() {
        // protected rootStore: Store<fromRoot.CoreState>
        // TODO: pull this from API first, environment as backup

        if (environment && environment.flags) {
            const flags = environment.flags;
            Object.keys(flags).forEach(k => {
                this.config[k] = flags[k] === true;
            });
        } else {
            throw new Error('No flags set in environment');
        }
    }
    public isEnabled = (flag: string) =>
        this.config[flag] === true ||
        (this.config['*'] === true && this.config[flag] === undefined);
}
